export const mindboxConfig = {
  endpointId: "gk-osnova.Website",
  pointOfContact: "zk-sensation.ru",
  brand: "gk-osnova",
  subscriptionPointOfContact: "Sms",
  disableTracker: true,
};

function normalizePhone(raw) {
  let digits = String(raw || "").replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "8") digits = "7" + digits.slice(1);
  if (digits.length === 10) digits = "7" + digits;
  return /^7\d{10}$/.test(digits) ? digits : "";
}

export function subscribeInFooter({ phone, email, isSubscribed = false } = {}) {
  if (typeof window.mindbox !== "function") return;
  const mobilePhone = normalizePhone(phone);
  if (!mobilePhone) return;

  const subscriptions = [];
  const isSubscribedBool = Boolean(isSubscribed);
  const emailTrim = email?.trim();

  const subscriptionSmsObject = {
    brand: mindboxConfig.brand,
    pointOfContact: mindboxConfig.subscriptionPointOfContact,
    isSubscribed: isSubscribedBool,
  };

  const subscriptionEmailObject = {
    brand: mindboxConfig.brand,
    pointOfContact: "Email",
    isSubscribed: Boolean(emailTrim),
  };

  if (!isSubscribedBool) {
    subscriptions;
  } else {
    if (emailTrim) {
      subscriptions.push(subscriptionSmsObject, subscriptionEmailObject);
    } else {
      subscriptions.push(subscriptionSmsObject);
    }
  }

  window.mindbox("async", {
    operation: "Website.SubscriptionInFooter",
    data: {
      pointOfContact: mindboxConfig.pointOfContact,
      customer: {
        mobilePhone,
        ...(email?.trim() ? { email: email.trim() } : {}),
        ...(subscriptions.length > 0 ? { subscriptions } : {}),
      },
    },
    onSuccess: () => console.log("[mindbox SUCCES] SubscriptionInFooter"),
    onError: (error) =>
      console.error("[mindbox ERROR] SubscriptionInFooter", error),
  });
}

export function viewProduct(productId) {
  if (typeof window.mindbox !== "function" || !productId) return;

  const data = {
    viewProduct: {
      product: {
        ids: { website: String(productId) },
      },
    },
  };

  window.mindbox("async", {
    operation: "Website.ViewProduct",
    data,
    onSuccess: () => console.log(`[mindbox SUCCES] ViewProduct`),
    onError: (error) => console.error("[mindbox ERROR] ViewProduct", error),
  });
}

export function setWishList(products = []) {
  if (typeof window.mindbox !== "function") return;

  const data = {
    productList: products.map((item) => ({
      product: {
        ids: { website: String(item.uuid) },
      },
      count: 1,
      pricePerItem: Number(item.price) || 0,
    })),
  };

  window.mindbox("async", {
    operation: "Website.SetWishList",
    data,
    onSuccess: () => console.log(`[mindbox SUCCES] SetWishList`),
    onError: (error) => console.error("[mindbox ERROR] SetWishList", error),
  });
}

export function clearWishList() {
  if (typeof window.mindbox !== "function") return

  window.mindbox('async', {
    operation: 'Website.ClearWishList',
    data: {},
    onSuccess: () => console.log(`[mindbox SUCCES] ClearWishList`),
    onError: (error) => console.error('[mindbox ERROR] ClearWishList', error),
  })
}
